// @flow

import React, {useEffect, useRef, useState} from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {CompanyContanier} from "../optionsStyles";
import CompanyBarcodeOptions from "./Options";

const BarcodeOptions = ({companyId}) => {
    const stores = useStore();
    const [companyRecall, setCompanyRecall] = useState(false);

    const companyRecallRef = useRef(companyRecall);
    companyRecallRef.current = companyRecall;

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.companyStore.getCompany.bind(null, {
            companyId,
            withSubCompanies: false,
            vehicleType: null
        }),
        dependencies: [companyRecall]
    });

    return (
        <div data-testid="barcodeOptionsFilter">
            <h2 data-testid="companyName">{companyData?.data?.companyName}</h2>
            <CompanyContanier>
                <CompanyBarcodeOptions
                    companyLoading={companyLoading}
                    setCompanyLoading={setCompanyLoading}
                    companyData={companyData}
                    setCompanyRecall={setCompanyRecall}
                    companyRecallRef={companyRecallRef}
                />
            </CompanyContanier>
        </div>
    );
};

export default BarcodeOptions;
